import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { INITPAGING, NOTIFY, PLATFORM } from "../based/Constants";
import { Notify } from "../based/Notify";
import TFUSelect from "../based/refactor/TFUSelect";
import PlatformServices from "../based/services/PlatformServices";
import PushingServices from "../based/services/PushingServices";
import ReadyListServices from "../based/services/ReadyListServices";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";
import Lazada from "./assets/Lazada.png";
import Shopee from "./assets/Shopee.png";
import Tiktok from "./assets/Tiktok.png";
import PushTemplateModal, { TemplateType } from "./PushTemplateModal";
import SelectDesignModal from "./SelectDesignModal";
import Common from "../based/Common";
import TextNumber from "../based/inputs/TextNumber";

const PackageType = {
    TShirt: 1,
    Case: 2,
    Bottle: 3,
    Pencase: 4,
    Sticker: 5,
};

const Artwork_Type = {
    Front: 1,
    Back: 2,
};

const CostDiscountType = {
    Fixed: 0,
    Voucher: 1,
    Marketing: 2,
    Other: 3,
};

const PushingProductMultiPlatformModel = {
    appCategoryId: 0,
    opfCategoryId: 0,
    platform: PLATFORM.Shopee,
    platformName: "",
    photoshopId: 0,
    platformBreadcrumb: "",
    photoshopFiles: [],
    photoshopProducts: [],
    shopOptions: [],
    shopId: "",
    listOPFCategory: [],
};

const FileType = {
    Normal: 0,
    Case: 1,
};

const PushingProductMultiModel = {
    id: 0,
    pushingProductId: 0,
    name: "",
    categoryId: 0,
    platformCategoryId: 0,
    platformBreadcrumb: "",
    brand: "Ranus",
    content: "",
    length: 0,
    width: 0,
    height: 0,
    weight: 0,
    printType: 0,
    photoshopId: 0,
    colorCode: "",
    colorName: "",
    appProductVariantId: "",
    platform: PLATFORM.Undefined,
    shopId: "",
    pushingProduct: {},
    pushingPhotoshopProducts: [],
    artworkType: Artwork_Type.Front,
    artworkCount: 1,
    multiPlatformModels: [PushingProductMultiPlatformModel],
    designId: 0,
    avatar: "",
    fileType: FileType.Normal,
    shopSetModels: [],
    packageType: 0,
};

const sizeSort = ["S", "M", "L", "XL", "2XL", "3XL", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

function PushingMultiDesignDetail(props) {
    const { designId } = props.match.params;
    const [model, setModel] = useState(PushingProductMultiModel);
    const history = useHistory();
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [templateType, setTemplateType] = useState(0);
    const [listProductNameTemplate, setListProductNameTemplate] = useState([]);
    const [listProductContentTemplate, setListProductContentTemplate] = useState([]);
    const location = useLocation();
    const [showSelectDesignModal, setShowSelectDesignModal] = useState(false);

    console.log("model", model);

    useEffect(() => {
        _getProductCustomizeMultiById();
    }, []);

    useEffect(() => {
        if (!showTemplateModal) {
            getListProductNameTemplate();
            getListProductContentTemplate();
        }
    }, [showTemplateModal]);

    //lấy template tên
    const getListProductNameTemplate = async () => {
        let [err, data] = await PlatformServices.GetTemplateDTOs({ ...INITPAGING, pageNumber: 1, pageSize: 100, type: TemplateType.ProductName });
        if (!err && data) {
            setListProductNameTemplate(data.listObjects);
        }
    };

    //lấy template nội dung
    const getListProductContentTemplate = async () => {
        let [err, data] = await PlatformServices.GetTemplateDTOs({ ...INITPAGING, pageNumber: 1, pageSize: 100, type: TemplateType.ProductContent });
        if (!err && data) {
            setListProductContentTemplate(data.listObjects);
        }
    };

    //platform đang được checked
    const checkedPlatform = useMemo(() => {
        let md = { ...model };
        let platforms = md.multiPlatformModels;
        if (!platforms || platforms.length == 0) return null;
        let platform = platforms.find((x) => x.isActive);
        return platform;
    }, [model]);

    //shop đang được checked
    const checkedShop = useMemo(() => {
        let md = { ...model };
        if (!md || !md.multiPlatformModels || md.multiPlatformModels.length == 0) return null;
        let platforms = md.multiPlatformModels;
        for (var pl of platforms) {
            var shopOptions = pl.shopOptions;
            if (shopOptions == null || shopOptions.length == 0) continue;
            for (var shop of shopOptions) {
                if (shop.isActive) {
                    shop.platform = pl.platform;

                    //lấy danh sách ngành hàng
                    if (shop.listOPFCategory && shop.listOPFCategory.length > 0) {
                        const listCat = shop.listOPFCategory.map((x) => {
                            return {
                                value: x.opfCategoryId,
                                label: x.platformBreadcrumb,
                            };
                        });
                        shop.listCat = listCat;
                    }

                    //lấy ds thương hiệu
                    if (shop.partnerPlatformBrands && shop.partnerPlatformBrands.length > 0) {
                        const listBrand = shop.partnerPlatformBrands.map((x) => {
                            return {
                                value: x.brandId,
                                label: x.brandName,
                            };
                        });
                        shop.listBrand = listBrand;
                    }

                    //lấy danh sách danh mục
                    const listShopCat = shop.listShopCatOption.map((x) => {
                        return {
                            value: x.id,
                            label: x.name,
                        };
                    });
                    shop.listShopCat = listShopCat;
                    return shop;
                }
            }
        }

        return null;
    }, [model]);

    //lấy danh sách kích thước của platform đang được checked
    const listPlatformsize = useMemo(() => {
        let md = { ...model };

        //lấy platform đang được checked
        let platforms = md.multiPlatformModels;
        if (!platforms || platforms.length == 0) return [];
        let platform = platforms.find((x) => x.isActive);
        if (!platform || !platform.shopOptions || platform.shopOptions.length == 0) return [];

        //lấy shop đang được checked
        let shopOptions = platform.shopOptions;
        let shop = shopOptions.find((x) => x.isActive);
        if (!shop || !shop.designProducts || shop.designProducts.length == 0) return;

        //merge ds listSize trong designProducts
        let listSize = [];
        for (var design of shop.designProducts) {
            if (design.listSize && design.listSize.length > 0) {
                design.listSize.forEach((size) => {
                    if (!listSize.some((x) => x.size === size.size)) {
                        listSize.push(size);
                    }
                });
            }
        }
        if (listSize && listSize.length > 0) {
            listSize.sort((a, b) => sizeSort.indexOf(a.size) - sizeSort.indexOf(b.size));
            return listSize;
        } else {
            return [];
        }
    }, [model]);

    //đếm tổng số thiết kế đang được active
    const totalCheckedDesigns = useMemo(() => {
        let md = { ...model };
        //lấy platform đang được active
        let platforms = md.multiPlatformModels;
        if (!platforms || platforms.length == 0) return 0;
        let platform = platforms.find((x) => x.isActive);
        if (!platform || !platform.shopOptions || platform.shopOptions.length == 0) return;
        0;
        //lấy shop đang được active
        let shopOptions = platform.shopOptions;
        let shop = shopOptions.find((x) => x.isActive);
        if (!shop || !shop.designProducts || shop.designProducts.length == 0) return 0;
        //đếm tổng số thiết kế đang được active
        let total = shop.designProducts.length;

        return total;
    }, [model]);

    //đếm tổng số biến thể đang được checked theo designProducts
    const totalCheckedVariants = useMemo(() => {
        //lấy ds platformSize được merge
        let sizeLength = listPlatformsize ? listPlatformsize.length : 0;
        if (sizeLength == 0) return 0;

        //lấy ds thiết kế
        let designLength = totalCheckedDesigns;

        let total = sizeLength * designLength;
        return total;
    }, [totalCheckedDesigns, listPlatformsize]);

    //lấy danh sách ảnh thumbnail theo design products
    const listThumbnail = useMemo(() => {
        let md = { ...model };
        //lấy platform đang được checked
        let platforms = md.multiPlatformModels;
        if (!platforms || platforms.length == 0) return [];
        let platform = platforms.find((x) => x.isActive);
        if (!platform || !platform.shopOptions || platform.shopOptions.length == 0) return [];
        //lấy shop đang được checked
        let shopOptions = platform.shopOptions;
        let shop = shopOptions.find((x) => x.isActive);

        if (!shop || !shop.designProducts || shop.designProducts.length == 0) return [];
        //lấy ds thumbnail
        let thumbnails = shop.designProducts.map((design) => {
            return {
                designId: design.designId,
                thumbnail: design.thumbnail,
                displayName: design.displayName,
                avatarChecked: design.avatarChecked,
            };
        });
        return thumbnails;
    }, [model]);

    //lấy thông tin đẩy sản phẩm
    async function _getProductCustomizeMultiById() {
        let [err, data] = await PushingServices.GetPushByMultiDesign();
        if (!err && data) {
            setModel(data);
        } else {
            setModel(null);
            Notify(NOTIFY.ERROR, "Lỗi", err.message);
        }
    }

    //lấy danh sách tùy chọn sản phẩm
    const getProductOptions = async (packageType) => {
        const [err, data] = await ReadyListServices.GetReadyProductOptions(packageType);
        if (!err) {
            return data.map((item) => ({
                label: item.name,
                value: item.id,
            }));
        } else return [];
    };

    //lấy danh sách tùy chọn màu sắc
    const getColorOptions = async (setId, appProductId) => {
        const [err, data] = await ReadyListServices.GetReadyProductColorOptionsBySetId(setId, appProductId);
        if (!err)
            return data.map((item) => ({
                label: item.displayName,
                value: item.name,
                templateImages: item.templateImages,
            }));
        else return [];
    };

    //lấy danh sách tùy chọn kích thước
    const getSize = async (model) => {
        const [err, data] = await ReadyListServices.GetReadyProductSizeOptions(model);
        if (!err) {
            let lstS = data.sort((a, b) => sizeSort.indexOf(a.size) - sizeSort.indexOf(b.size));
            return lstS;
        } else return [];
    };

    async function createUpdatePushProduct() {
        let md = { ...model };
        md.designId = +designId;
        md.multiPlatformModels = md.multiPlatformModels.filter((x) => x.shopOptions.some((y) => y.isChecked && y.designProducts != null && y.designProducts.length > 0));

        if (!md.multiPlatformModels || md.multiPlatformModels.length == 0) {
            Notify(NOTIFY.ERROR, "Lỗi", "Vui lòng chọn shop muốn đẩy");
            return;
        }

        //loop qua từng platform
        for (let platform of md.multiPlatformModels) {
            //loop qua từng shop
            for (let shop of platform.shopOptions) {
            }
        }

        let [err, data] = await PushingServices.CreateUpdatePushDesignMulti(md);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Đẩy sản phẩm thành công, hệ thống sẽ tự động cập nhật sản phẩm sau ít phút");
            setTimeout(() => {
                history.push("/pushing-design-manage");
            }, 1000);
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", err.message);
        }
    }

    function getImage(platform) {
        switch (platform) {
            case PLATFORM.Shopee:
                return <img src={Shopee} />;
            case PLATFORM.Lazada:
                return <img src={Lazada} />;
            case PLATFORM.Tiktok:
                return <img src={Tiktok} />;
            default:
                return "";
        }
    }

    if (!model) return <div>Hiện tại không có dữ liệu</div>;
    return (
        <React.Fragment>
            <Breadcum
                options={[
                    {
                        value: "/",
                        label: "Trang chủ",
                    },
                    {
                        value: "/pushing-manage",
                        label: "Đẩy sản phẩm",
                    },
                    {
                        value: location.pathname,
                        label: "Chi tiết đẩy sản phẩm",
                    },
                ]}
                title={"Chi tiết đẩy sản phẩm theo nhóm thiết kế"}
            />
            <Wrapper>
                <section className="product_info">
                    <div className="product_info-body">
                        <div className="info-row">
                            <label htmlFor="" className="required">
                                Tên sản phẩm
                            </label>
                            <div className="info-input">
                                <div className="template">
                                    <div className="list-tag">
                                        {listProductNameTemplate &&
                                            listProductNameTemplate.length > 0 &&
                                            listProductNameTemplate.map((item, index) => {
                                                return (
                                                    <div
                                                        className="tag cursor-pointer"
                                                        key={index}
                                                        onClick={(e) => {
                                                            let content = item.content;

                                                            //replace SET_TITLE
                                                            content = content.replace("SET_TITLE", model.designName);
                                                            setModel({ ...model, name: content });
                                                        }}
                                                    >
                                                        {item.title}
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                                <div className="input-area">
                                    <input
                                        type="text"
                                        value={model.name}
                                        onChange={(e) => {
                                            let length = e.target.value.length;
                                            let name = model.name ?? "";
                                            if (length < name.length) {
                                                setModel({ ...model, name: e.target.value });
                                            } else {
                                                if (length > 120) return;
                                                setModel({ ...model, name: e.target.value });
                                            }
                                        }}
                                    />
                                    <span className="suffix">{model && model.name ? model.name.length : 0}/120</span>
                                </div>
                            </div>
                        </div>
                        <div className="info-row">
                            <label htmlFor="" className="required">
                                Mô tả thiết kế
                            </label>
                            <div className="info-input">
                                <div className="template">
                                    <div className="list-tag">
                                        {listProductContentTemplate &&
                                            listProductContentTemplate.length > 0 &&
                                            listProductContentTemplate.map((item, index) => {
                                                return (
                                                    <div
                                                        className="tag cursor-pointer"
                                                        key={index}
                                                        onClick={(e) => {
                                                            let content = item.content;
                                                            content = content.replace("SET_TITLE", model.designName);
                                                            setModel({ ...model, content: content });
                                                        }}
                                                    >
                                                        {item.title}
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                                <div className="input-area">
                                    <textarea
                                        rows={5}
                                        type="text"
                                        value={model.content}
                                        onChange={(e) => {
                                            setModel({ ...model, content: e.target.value });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="push_product">
                    <section className="push_shop">
                        <h6>Chọn shop muốn đẩy</h6>
                        {model.multiPlatformModels &&
                            model.multiPlatformModels.map((item, index) => {
                                if (!item.shopOptions || item.shopOptions.length == 0) return "";
                                return (
                                    <div className="shop-platform" key={index}>
                                        <div className="heading">
                                            <div className="icon">{getImage(item.platform)}</div>
                                        </div>
                                        <div className="list-shop">
                                            {item.shopOptions &&
                                                item.shopOptions.length > 0 &&
                                                item.shopOptions.map((shop, idx) => {
                                                    return (
                                                        <div className={`shop-item ${shop.isActive ? "active" : ""}`} key={idx}>
                                                            <input
                                                                type="checkbox"
                                                                checked={shop.isChecked}
                                                                onChange={(e) => {
                                                                    shop.isChecked = e.target.checked;
                                                                    setModel({ ...model });
                                                                }}
                                                                className="cursor-pointer"
                                                            />
                                                            <div
                                                                className="shop-name cursor-pointer"
                                                                onClick={(e) => {
                                                                    let md = { ...model };
                                                                    let platforms = md.multiPlatformModels;
                                                                    for (var pl of platforms) {
                                                                        if (pl.shopOptions)
                                                                            pl.shopOptions.forEach((x) => {
                                                                                x.isActive = false;
                                                                            });
                                                                    }
                                                                    let platform = platforms[index];
                                                                    platform.isActive = true;
                                                                    let shopOptions = platform.shopOptions;
                                                                    let current = shopOptions[idx];
                                                                    current.isActive = true;
                                                                    setModel({ ...model });
                                                                }}
                                                            >
                                                                {shop.label}
                                                                {shop.pushingProductId > 0 && <div className="badge badge-orange">Đã đẩy</div>}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                );
                            })}
                    </section>

                    {/* Tùy chọn shop */}
                    {checkedShop && (
                        <section className="design_detail">
                            <PickDesignWrapper>
                                <h6>Tùy chọn shop</h6>
                                <div className="design_detail-body">
                                    <section className="design_detail-shop">
                                        <div className="design_detail-header">
                                            {checkedPlatform && <div className="icon">{getImage(checkedPlatform.platform)}</div>}
                                            <div className="detail-shop-name">{checkedShop.label}</div>
                                            {/* <div className="float-right">
                                                <a
                                                    className="text text-custom cursor-pointer"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                    }}
                                                >
                                                    Áp dụng cho tất cả shop khác
                                                </a>
                                            </div> */}
                                        </div>
                                        <div className="design_detail-body-shop">
                                            <div className="design_detail-body-left">
                                                <label>Hình ảnh sản phẩm</label>
                                                <div className="lst-design-avatar">
                                                    {listThumbnail && listThumbnail.length > 0
                                                        ? listThumbnail.map((item, index) => (
                                                              <div
                                                                  className={`design-avatar cursor-pointer ${item.avatarChecked ? "checked" : ""}`}
                                                                  key={index}
                                                                  onClick={(e) => {
                                                                      let md = { ...model };
                                                                      let platforms = md.multiPlatformModels;
                                                                      let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                      let shopOptions = platform.shopOptions;
                                                                      let current = shopOptions.find((x) => x.value == checkedShop.value);
                                                                      if (current) {
                                                                          current.designProducts.forEach((design) => {
                                                                              design.avatarChecked = false;
                                                                          });

                                                                          let design = current.designProducts.find((x) => x.designId == item.designId);
                                                                          if (design) {
                                                                              design.avatarChecked = true;
                                                                          }
                                                                      }
                                                                      setModel({ ...md });
                                                                  }}
                                                              >
                                                                  <img src={item.thumbnail} alt="" />
                                                                  {item.avatarChecked && (
                                                                      <div className="checked-overlay">
                                                                          <span>Đang chọn</span>
                                                                      </div>
                                                                  )}
                                                              </div>
                                                          ))
                                                        : null}
                                                </div>
                                            </div>
                                            <div className="design_detail-body-right">
                                                <div className="push_detail-cat">
                                                    <div className="cat-left">
                                                        <label htmlFor="" className="required">
                                                            Thương hiệu
                                                        </label>
                                                        <TFUSelect
                                                            placeholder="Chọn thương hiệu"
                                                            options={checkedShop.listBrand}
                                                            value={checkedShop.brandId}
                                                            onChanged={(newValue) => {
                                                                let md = { ...model };
                                                                let platforms = md.multiPlatformModels;
                                                                let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                let shopOptions = platform.shopOptions;
                                                                let current = shopOptions.find((x) => x.value == checkedShop.value);
                                                                current.brandId = newValue;
                                                                setModel({ ...model });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="push_detail-cat">
                                                    <div className="cat-left">
                                                        <label htmlFor="" className="required">
                                                            Ngành hàng
                                                        </label>
                                                        <TFUSelect
                                                            placeholder="Chọn ngành hàng"
                                                            options={checkedShop.listCat}
                                                            value={checkedShop.opfCategoryId}
                                                            onChanged={(newValue) => {
                                                                let md = { ...model };
                                                                let platforms = md.multiPlatformModels;
                                                                let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                let shopOptions = platform.shopOptions;
                                                                let current = shopOptions.find((x) => x.value == checkedShop.value);
                                                                current.opfCategoryId = newValue;
                                                                setModel({ ...model });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <section className="design_detail-multi">
                                        <h6>Chọn thiết kế</h6>
                                        <div className="table-design">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Thiết kế ({totalCheckedDesigns})</th>
                                                        <th>Tên hiển thị</th>
                                                        <th>Dòng sản phẩm</th>
                                                        <th>Giá bán trên sàn</th>
                                                        {/* <th>Lợi nhuận gộp tạm tính</th> */}
                                                        <th>Giá bán trên Ranus</th>
                                                        {/* <th>Tổng chi phí tạm tính</th> */}
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {checkedShop && checkedShop.designProducts
                                                        ? checkedShop.designProducts.map((design, index) => {
                                                              return (
                                                                  <tr key={index}>
                                                                      <td>
                                                                          <div className="design_detail-info">
                                                                              <div className="design_detail-info-img">
                                                                                  <img src={design.thumbnail} alt="" />
                                                                              </div>
                                                                              <div className="design_detail-info-name">
                                                                                  <p>{design.name}</p>
                                                                              </div>
                                                                          </div>
                                                                      </td>
                                                                      <td>
                                                                          <div className="design_detail-info-display-name">
                                                                              <input
                                                                                  type="text"
                                                                                  value={design.displayName}
                                                                                  onChange={(e) => {
                                                                                      let md = { ...model };
                                                                                      let platforms = md.multiPlatformModels;
                                                                                      let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                                      let shopOptions = platform.shopOptions;
                                                                                      let currentShop = shopOptions.find((x) => x.value == checkedShop.value);
                                                                                      if (currentShop) {
                                                                                          currentShop.designProducts[index].displayName = e.target.value;
                                                                                      }
                                                                                      setModel({ ...md });
                                                                                  }}
                                                                              />
                                                                              <div className="text-count">{design.displayName && <span>{design.displayName.length}/20</span>}</div>
                                                                          </div>
                                                                      </td>
                                                                      <td>
                                                                          <div className="product-type">
                                                                              <TFUSelect
                                                                                  placeholder="Chọn dòng sản phẩm"
                                                                                  options={design.productOptions}
                                                                                  value={design.appProductId}
                                                                                  onChanged={async (newValue) => {
                                                                                      let md = { ...model };
                                                                                      let platforms = md.multiPlatformModels;
                                                                                      let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                                      let shopOptions = platform.shopOptions;
                                                                                      let currentShop = shopOptions.find((x) => x.value == checkedShop.value);
                                                                                      let element = currentShop.designProducts[index];
                                                                                      if (currentShop) {
                                                                                          element.appProductId = newValue;
                                                                                          element.appProductName = design.productOptions.find((x) => x.value == newValue).name;
                                                                                      }

                                                                                      //lấy danh sách tùy chọn kích thước
                                                                                      let lstSize = await getSize({
                                                                                          appProductId: +newValue,
                                                                                          colorCode: design.colorCode,
                                                                                          designId: design.designId,
                                                                                      });

                                                                                      //cập nhập sale price, thumbnail
                                                                                      let salePrice = 0;
                                                                                      let thumbnail = "";
                                                                                      if (lstSize && lstSize.length > 0) {
                                                                                          salePrice = lstSize[0].salePrice;
                                                                                          thumbnail = lstSize[0].avatar;
                                                                                      }
                                                                                      element.sellPrice = salePrice;
                                                                                      element.partnerSellPrice = salePrice;
                                                                                      element.thumbnail = thumbnail;
                                                                                      element.listSize = lstSize;
                                                                                      setModel({ ...md });
                                                                                  }}
                                                                                  name={`product-type-${index}`}
                                                                              />
                                                                          </div>
                                                                      </td>
                                                                      <td>
                                                                          <div className="platform-price">
                                                                              <TextNumber
                                                                                  name={`platform-price-${index}`}
                                                                                  className="form-control"
                                                                                  value={design.sellPrice}
                                                                                  onChanged={(name, val) => {
                                                                                      let md = { ...model };
                                                                                      let platforms = md.multiPlatformModels;
                                                                                      let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                                      let shopOptions = platform.shopOptions;
                                                                                      let currentShop = shopOptions.find((x) => x.value == checkedShop.value);
                                                                                      if (currentShop) {
                                                                                          currentShop.designProducts[index].sellPrice = +val;
                                                                                      }
                                                                                      setModel({ ...md });
                                                                                  }}
                                                                              />
                                                                              {/* <input
                                                                                  type="number"
                                                                                  value={design.sellPrice}
                                                                                  onChange={(e) => {
                                                                                      let md = { ...model };
                                                                                      let platforms = md.multiPlatformModels;
                                                                                      let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                                      let shopOptions = platform.shopOptions;
                                                                                      let currentShop = shopOptions.find((x) => x.value == checkedShop.value);
                                                                                      if (currentShop) {
                                                                                          currentShop.designProducts[index].sellPrice = +e.target.value;
                                                                                      }
                                                                                      setModel({ ...md });
                                                                                  }}
                                                                              /> */}
                                                                          </div>
                                                                      </td>
                                                                      {/* <td>
                                                                          <div className="revenue-item">
                                                                              <input className="revenue-left" />
                                                                              <span>Hoặc</span>
                                                                              <input className="revenue-right" />
                                                                          </div>
                                                                      </td> */}
                                                                      <td>
                                                                          <div className="ranus-price">
                                                                              <span>{Common.formatCurrency(design.partnerSellPrice)}</span>
                                                                          </div>
                                                                      </td>
                                                                      {/* <td>
                                                                          <div className="total-cost">
                                                                              <span>30000</span>
                                                                          </div>
                                                                      </td> */}
                                                                      <td>
                                                                          <div className="action">
                                                                              {/* <button className="btn btn-primary">Chọn</button> */}

                                                                              <button
                                                                                  className="btn btn-danger"
                                                                                  onClick={(e) => {
                                                                                      e.stopPropagation();
                                                                                      // Handle delete action
                                                                                      let md = { ...model };
                                                                                      let platforms = md.multiPlatformModels;
                                                                                      let platform = platforms.find((x) => x.platform == checkedShop.platform);
                                                                                      let shopOptions = platform.shopOptions;
                                                                                      let currentShop = shopOptions.find((x) => x.value == checkedShop.value);
                                                                                      if (currentShop) {
                                                                                          currentShop.designProducts.splice(index, 1);
                                                                                      }
                                                                                      setModel({ ...md });
                                                                                  }}
                                                                              >
                                                                                  <i className="fa fa-trash"></i>
                                                                              </button>
                                                                          </div>
                                                                      </td>
                                                                  </tr>
                                                              );
                                                          })
                                                        : null}
                                                </tbody>
                                            </table>
                                            <div className="pick-design">
                                                <button
                                                    className="btn btn-orange"
                                                    onClick={(e) => {
                                                        setShowSelectDesignModal(true);
                                                    }}
                                                >
                                                    Thêm thiết kế <i className="fa fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="section-size">
                                            <span>Size khả dụng ({listPlatformsize && listPlatformsize.length}) </span>
                                            <div className="lst-size-combine">
                                                {listPlatformsize &&
                                                    listPlatformsize.map((size, index) => (
                                                        <div className="size-item" key={index}>
                                                            <span className="size-name">{size.size}</span>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                        {totalCheckedVariants > 100 && (
                                            <div className="section-txt-danger">
                                                <div className="icon-danger">
                                                    <i className="fa"></i>
                                                </div>
                                                <div className="alert-txt">
                                                    <div className="main-alert">Vượt quá 100 biến thể. Không thể đẩy sản phẩm.</div>
                                                    <div className="sub-alert">
                                                        {totalCheckedDesigns} thiết kế x {listPlatformsize ? listPlatformsize.length : 0} size = {totalCheckedVariants} biến thể. Vui lòng giảm thiết kế để tiếp tục.
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </section>
                                </div>
                            </PickDesignWrapper>
                        </section>
                    )}

                    {/* Danh sách button xử lý */}
                    <section className="btn-bottom">
                        <div className="list-button">
                            <button
                                className="btn btn-secondary"
                                onClick={(e) => {
                                    history.push("/pushing-manage");
                                }}
                            >
                                Trở về
                            </button>

                            <button
                                className="btn btn-orange"
                                onClick={(e) => {
                                    createUpdatePushProduct();
                                }}
                            >
                                {"Đẩy sản phẩm"}
                            </button>
                        </div>
                    </section>
                </section>
            </Wrapper>
            <PushTemplateModal show={showTemplateModal} onClose={() => setShowTemplateModal(false)} templateType={templateType} />
            <SelectDesignModal
                show={showSelectDesignModal}
                onClose={() => {
                    setShowSelectDesignModal(false);
                }}
                listCheckedDesignProduct={checkedShop ? checkedShop.designProducts : []}
                onSave={async (val) => {
                    console.log(val);
                    //add vào model
                    let md = { ...model };
                    let platforms = md.multiPlatformModels;
                    let platform = platforms.find((x) => x.isActive);
                    if (platform) {
                        let shopOptions = platform.shopOptions;
                        let currentShop = shopOptions.find((x) => x.isActive);
                        if (currentShop) {
                            if (currentShop.designProducts == null) currentShop.designProducts = [];
                            let dp = [];
                            for (const x of val) {
                                //nếu đã chọn rồi thì ignore
                                if (currentShop.designProducts.find((y) => y.designId == x.designId)) continue;

                                //lấy ds option sản phẩm
                                let productOptions = await getProductOptions(x.packageType);

                                //lấy ds option kích thước
                                let lstSize = await getSize({
                                    appProductId: +x.appProductId,
                                    colorCode: x.colorCode,
                                    designId: x.designId,
                                });

                                //lấy ra salePrice, thumbnail
                                let salePrice = x.salePrice;
                                let thumbnail = x.thumbnail;
                                if (lstSize && lstSize.length > 0) {
                                    salePrice = lstSize[0].salePrice;
                                    thumbnail = lstSize[0].avatar;
                                }

                                dp.push({
                                    designId: x.designId,
                                    name: x.name,
                                    displayName: x.name,
                                    thumbnail: thumbnail,
                                    appProductId: x.appProductId,
                                    partnerSellPrice: salePrice,
                                    sellPrice: salePrice,
                                    packageType: x.packageType,
                                    printType: x.printType,
                                    productOptions: productOptions,
                                    listSize: lstSize,
                                    colorCode: x.colorCode,
                                });
                            }

                            //auto checked item đầu
                            if (currentShop.designProducts.length == 0 && dp.length > 0) {
                                let firstDesign = dp[0];
                                firstDesign.avatarChecked = true;
                            }

                            currentShop.designProducts = [...currentShop.designProducts, ...dp];
                        }
                    }
                    setModel({ ...md });

                    //đóng modal
                    setShowSelectDesignModal(false);
                }}
            />
        </React.Fragment>
    );
}

export default PushingMultiDesignDetail;

const PickDesignWrapper = styled.div`
    .design-avatar {
        position: relative;
    }

    .checked-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 0px 0px 8px 8px;
        background: rgba(255, 144, 39, 0.7);
        display: flex;
        justify-content: center;
        padding: 12px;
    }

    .checked-overlay span {
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .design-avatar {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        overflow: hidden;
    }

    .design-avatar.checked {
        border: 1px solid #ff9027;
    }

    .design_detail-info-name {
        margin-left: 12px;
    }
    .platform-price {
        padding: 4px;
    }

    .ranus-price {
        padding: 4px;
    }
    .section-size {
        display: flex;
        padding: 16px 24px;
        align-items: center;
    }

    .lst-size-combine {
        display: flex;
        margin-left: 16px;
    }

    .section-size > span {
        color: #303030;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .size-item {
        border-radius: 8px;
        background: #f3f3f3;
        padding: 12px 26px;
        margin: 5px;
    }

    span.size-name {
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .section-txt-danger {
        border: 1px solid #f3f3f3;
        background: #ffe4e4;
        display: flex;
        padding: 16px 24px;
        align-items: center;
    }

    .alert-txt {
        margin-left: 16px;
    }

    .main-alert {
        color: #303030;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .sub-alert {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 8px;
    }

    section.design_detail-multi {
        overflow: hidden;
    }

    section.design_detail-multi h6 {
        padding: 16px 24px;
    }

    .table-design {
        padding: 16px 24px;
    }

    section.design_detail-shop {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
    }

    .design_detail-header {
        display: flex;
        align-items: center;
        padding: 16px 24px;
        border-bottom: 1px solid #f3f3f3;
    }

    .design_detail-body-shop {
        display: flex;
        padding: 16px 24px;
    }

    .design_detail-body-left {
        width: 70%;
    }

    .design-avatar {
        width: 96px;
        height: 96px;
        margin: 5px;
    }

    .design-avatar img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .lst-design-avatar {
        display: flex;
        flex-wrap: wrap;
    }

    .design_detail-body-right {
        flex: 1;
        margin-left: 8px;
    }

    section.design_detail-multi {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        margin: 12px 0;
    }

    section.design_detail-multi h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .table-design {
        overflow-x: auto;
    }

    table.table.table-bordered {
        width: 100%;
    }

    .design_detail-info {
        display: flex;
        width: 200px;
    }

    .design_detail-info-img {
        width: 72px;
        height: 72px;
    }

    .design_detail-info-img img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .design_detail-info-name {
        flex: 1;
    }

    .design_detail-info-display-name {
        display: flex;
        height: 38px;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        overflow: hidden;
    }

    .design_detail-info-display-name input {
        flex: 1;
        border: none;
        padding: 6px;
    }

    .text-count {
        width: 40px;
        display: flex;
        vertical-align: middle;
        justify-content: center;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
    }

    .text-count span {
        align-self: center;
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .product-type {
        width: 180px;
        height: 38px;
    }

    .product-type div {
        /* height: 100%; */
    }

    .platform-price {
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #e5e5e5;
    }

    .platform-price input {
        border: none;
    }

    .revenue-item {
        display: flex;
        align-items: center;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #e5e5e5;
        height: 38px;
    }

    .revenue-item span {
        display: flex;
        width: 43px;
        height: 38px;
        flex-shrink: 0;
        align-self: center;
        border: 1px solid #e5e5e5;
        background: #444;
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        justify-content: center;
        align-items: center;
    }

    .revenue-item input {
        height: 38px;
        border: none;
        width: 84px;
        flex-shrink: 0;
    }

    .ranus-price span {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .ranus-price {
        display: flex;
        align-items: center;
    }

    .total-cost {
        height: 38px;
        display: flex;
        align-items: center;
        width: 60px;
    }

    .total-cost span {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
`;

const Wrapper = styled.div`
    width: 90%;

    section.design_detail {
        flex: 1 1 0%;
        width: calc(100% - 294px);
        margin-left: 24px;
    }

    .cat-left input[type="text"] {
        width: 100%;
    }

    .input-group-revenue .input-group {
        display: flex;
        flex-wrap: nowrap;
        border: 1px solid rgb(229, 229, 229);
        border-radius: 6px 0 0 6px;
    }

    .input-group-revenue .input-group .input-group-append .input-group-text {
        background: transparent;
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: auto !important;
        height: auto;
        border: none;
    }

    input.revenue.form-control {
        border: none;
    }

    input.revenue-percentage.form-control {
        border: none;
    }

    .input-group.right {
        border-radius: 0 6px 6px 0;
    }
    .right-list-btn {
        margin-left: auto;
    }

    .push_detail-price-stock {
        display: flex;
        flex-wrap: wrap;
    }

    .section-table {
        margin-top: 16px;
    }

    .show-cost {
        display: flex;
        align-items: center;
        border-radius: 8px;
        border: 1px solid #ffe3c9;
        background: #fff5ec;
        padding: 6px 12px;
    }

    .show-cost span {
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .show-cost span img {
        margin-right: 6px;
    }

    .list-button {
        margin: 0 0 0 auto;
    }

    button.btn.btn-secondary {
    }

    section.btn-bottom {
        margin: 12px 0;
        display: flex;
    }

    button.btn.btn-secondary {
        border-radius: 40px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        color: #000;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    button.btn {
        margin: 0 10px;
    }

    button.btn.btn-orange {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .fixed-table {
        table-layout: fixed;
        width: 100%;
    }

    .col-product {
        width: 190px;
    }

    .col-ranus-price {
        width: 80px;
    }

    .col-tiktok-price {
        width: 110px;
    }

    .col-profit {
        width: 220px;
    }

    .col-costs-group {
        width: 840px;
    }

    .col-cost {
        width: 140px;
        padding: 10px;
    }

    .col-default,
    .col-visible {
        width: 60px;
        padding: 10px;
    }

    img.img-row {
        width: 80px;
        height: 80px;
        object-fit: contain;
        padding: 4px;
    }

    td.row-name {
        color: #303030;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    td.partner-sell-price {
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .input-group-revenue {
        display: flex;
        align-items: center;
        height: 33px;
    }

    .input-group-revenue span {
        width: 50px !important;
    }

    td.platform-sell-price {
        padding: 5px;
    }

    td.center.profit {
        padding: 5px;
    }

    input.revenue {
        border-radius: 8px 0px 0px 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 5px 0 5px 5px;
    }

    .input-group-revenue span {
        border: 1px solid #e5e5e5;
        background: #444;
        color: white;
        height: 33px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 5px;
    }

    input.revenue-percentage {
        border-radius: 0px 8px 8px 0px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 5px 5px 5px 0;
    }

    .section-table {
        overflow: auto;
    }

    table.table.table-bordered {
        overflow: auto;
    }

    table.table-wrapper {
        overflow-x: auto;
    }

    .table-scrollable {
        overflow-x: auto;
        width: 100%;
    }

    section.detail-product {
        margin: 12px 0;
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 12px;
    }

    section.push_detail {
        width: calc(100% - 270px - 24px);
        margin-left: 24px;
    }

    .push_detail h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 100% */
    }

    section.detail-info {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
    }

    .push_detail-header {
        padding: 16px;
        display: flex;
        align-items: center;
        border: 1px solid #f3f3f3;
    }

    .float-right {
        margin-left: auto;
        border-radius: 8px;
        border: 1px solid #ffe3c9;
        background: #fff5ec;
        padding: 8px;
    }

    .push_detail-header .icon {
        height: 23px;
        width: auto;
    }

    .push_detail-header .icon img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .detail-shop-name {
        color: #444;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-left: 12px;
    }

    .float-right a {
        color: #ff9027 !important;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .push_detail-image {
        padding: 16px;
        display: flex;
    }

    .push_detail-image-left {
        width: 30%;
    }

    .push_detail-image-right {
        flex: 1;
        margin-left: 24px;
    }

    .push_detail-cat {
        margin: 10px 0;
    }

    .list-file {
        display: flex;
        flex-wrap: wrap;
    }

    .file-item {
        width: 85px;
        height: 85px;
        border-radius: 10px;
        overflow: hidden;
        margin: 5px 5px 5px 0;
    }

    .file-item.active {
        border-radius: 8px;
        border: 1px solid #ff9027;
        background: linear-gradient(0deg, rgba(255, 144, 39, 0.3) 0%, rgba(255, 144, 39, 0.3) 100%), url(<path-to-image>) lightgray 50% / cover no-repeat;
    }

    .file-item.active .file-avatar {
        opacity: 0.5;
    }

    section.push_product {
        display: flex;
        flex-wrap: wrap;
        margin: 12px 0;
    }

    section.btn-bottom {
        width: 100%;
    }

    section.push_shop {
        width: 270px;
    }

    section.push_detail {
        flex: 1;
    }

    .push_shop h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 100% */
    }

    .shop-platform {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 16px;
    }

    .heading .icon {
        height: 20px;
    }

    .shop-item {
        display: flex;
        align-items: center;
        margin: 10px 0;
        border-radius: 8px;
        padding: 8px;
    }

    .shop-name {
        color: #444;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 153.846% */
        margin-left: 6px;
        display: flex;
        align-items: center;

        .badge {
            margin-left: 6px;
        }
    }

    .stick-left {
        position: sticky;
        left: 0;
        background: rgb(255, 255, 255);
        z-index: 100;
    }

    .stick-right {
        position: sticky;
        right: 0;
        background: rgb(255, 255, 255);
        z-index: 100;
    }

    .shop-item.active {
        border-radius: 8px;
        background: #fff5ec;
    }

    .file-avatar {
        width: 85px;
        height: 85px;
        aspect-ratio: 1/1;
    }

    .file-avatar img {
        width: 100%;
        height: 100%;
    }
    /* thông tin sản phẩm */
    section.product_overview {
        margin: 12px 0;
    }

    section.product_info {
        margin: 12px 0;
    }

    section.product_info {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 20px 24px;
    }

    .info-row {
        display: flex;
        margin: 16px 0;
    }

    .info-row label.required {
        width: 15%;
    }

    .info-input {
        flex: 1;
    }

    .template {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }

    .list-tag {
        display: flex;
    }

    .open-template {
        margin-left: auto;
    }

    .tag {
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        margin: 0 10px;
    }

    .tag:first-child {
        margin-left: 0;
    }

    .icon {
        display: flex;
    }

    .input-area input[type="text"] {
        border: none;
        flex: 1;
    }

    .input-area {
        display: flex;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        align-items: center;
        padding: 9px 17px;
    }

    .input-area textarea {
        width: 100%;
        border: none;
    }

    /* avatar */
    .avatar {
        width: 120px;
        height: 120px;
    }

    .avatar img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    section.product_overview {
        display: flex;
        border-radius: 12px;
        background: #fff;
        padding: 24px;
    }

    .overview-section {
        margin-left: 36px;
    }

    .overview-title {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .overview-color {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 12px 0;
    }
`;

const OpenTemplateIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z"
                stroke="#FF9027"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z"
                stroke="#FF9027"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
